<template>
  <el-card class="box-card">
    <div class="row" style="margin-top: 15px">
      <div class="col-md-3">
        <el-input
          v-model="queryMenuCoupon.q"
          placeholder="回数券名・ID"
          @keyup.enter.native="filterMenuClinics"
        >
        </el-input>
      </div>
      <div class="col-md-3">
        <el-input
          v-model="queryMenuCoupon.query"
          placeholder="担当者"
          @keyup.enter.native="filterMenuClinics"
        >
        </el-input>
      </div>
      <el-select
        class="col-md-3"
        v-model="queryMenuCoupon.filter"
        filterable
        multiple
        placeholder="店舗選択"
        collapse-tags
        @click="filterMenuClinics"
        @change="handleClinicChange"
      >
        <el-option :label="'すべて'" :value="'select-all'"></el-option>
        <el-option
          v-for="clinicNameMenuCoupon in clinicNameMenuCoupons"
          :key="clinicNameMenuCoupon.id"
          :label="clinicNameMenuCoupon.clinic_name"
          :value="clinicNameMenuCoupon.id"
        >
        </el-option>
      </el-select>
      <div class="col-md-3 form-group">
        <el-button
          slot="append"
          @click="filterMenuClinics"
          name="button"
          type="submit"
          style="background-color: #51bcda; color: #ffffff"
          class="btn btn-info m-0"
        >
          <i class="fa fa-search search-text" aria-hidden="true"></i>
          検索する
        </el-button>
      </div>
    </div>
  </el-card>
</template>

<script>
import { mapGetters, mapActions } from "vuex"

export default {
  computed: {
    ...mapGetters(['clinicNameMenuCoupons', 'queryMenuCoupon', 'menuCoupons']),
  },
  methods: {
    ...mapActions('menu_coupon', ['fetchMenuCoupons', 'fetchClinicNameMenuCoupons']),
    filterMenuClinics() {
      this.fetchMenuCoupons()
    },
    handleClinicChange(value) {
      if (value.includes('select-all')) {
        if (this.queryMenuCoupon.filter.length === this.clinicNameMenuCoupons.length + 1) {
          this.queryMenuCoupon.filter = [];
        } else {
          this.queryMenuCoupon.filter = this.clinicNameMenuCoupons.map(clinic => clinic.id);
        }
      }
      this.filterMenuClinics()
    },
  }

}
</script>

<style>
.d-flex {
  display: flex;
}

.child-div {
  margin-top: 15px;
}
</style>
